import {
  DeleteSVG,
  GetSVGProperties,
  PatchSVGProperties,
  SVGProperties,
} from '@/api/svg'
import Vue from 'vue'

export default Vue.extend({
  name: 'ViewMixins',
  data() {
    return {
      optsRoles: [
        { text: 'Standar user', value: 'user' },
        { text: 'Operator', value: 'operator' },
        { text: 'Admin', value: 'admin' },
      ],
      viewProperties: {} as SVGProperties,
    }
  },

  methods: {
    async getProperties() {
      const uid = this.$route.params.viewUID
      this.viewProperties = await GetSVGProperties(uid)
    },

    async patchSVGProperties() {
      const uid = this.$route.params.viewUID
      this.viewProperties = await PatchSVGProperties(uid, this.viewProperties)
    },

    async deleteView() {
      const uid = this.$route.params.viewUID
      await DeleteSVG(uid)
      this.$router.go(-1)
    },

    async patchView() {
      //
    },
  },
})
